<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 116.17 105.62">
    <path :fill="iconColor" d="M110.89,63.37h0s-5.28,0-5.28,0c0-2.67-.29-5.28-.82-7.79-.16-.11-.31-.23-.45-.37l-26.02-26.04c-.46-.46-.76-1.01-.9-1.59-.27-.07-.52-.17-.77-.3-2.56-.56-5.22-.87-7.95-.87-.02,0-.04,0-.06,0h-5.28v-6.7c5.05-2.92,6.78-9.38,3.87-14.43-2.92-5.05-9.38-6.78-14.43-3.87-5.05,2.92-6.78,9.38-3.87,14.43.93,1.61,2.26,2.94,3.87,3.87v6.7h-5.28c-20.4-.02-36.95,16.51-36.96,36.91v.06h-5.28c-2.91.01-5.27,2.37-5.28,5.28v15.84c.01,2.91,2.37,5.27,5.28,5.28h5.28v5.28c0,5.83,4.72,10.56,10.55,10.56h73.93c5.81.02,10.54-4.67,10.56-10.49,0-.02,0-.05,0-.07v-5.28h5.28c2.91-.01,5.27-2.37,5.28-5.28v-15.84c-.01-2.91-2.37-5.27-5.28-5.28ZM40.55,79.43l-6.23-6.23-6.23,6.23-6.23-6.23,12.46-12.46,12.46,12.46-6.23,6.23ZM88.08,79.43l-6.23-6.23-6.23,6.23-6.23-6.23,12.46-12.46,12.46,12.46-6.23,6.23Z" />
    <path :fill="badgeColor" d="M73.9,16.67s.01-.01.02-.02l5.5-5.5c.44-.46,1.04-.69,1.64-.69s1.22.23,1.68.69l4.04,4.02c.16.16.16.41,0,.57l-8.25,8.25c-.16.16-.42.16-.57,0l-3.99-4.09c-.86-.88-.9-2.28-.08-3.21l.02-.02ZM115.56,52.41v-8.25c0-.11-.04-.21-.12-.28l-25.62-25.64c-.16-.16-.41-.16-.57,0l-8.25,8.25c-.16.16-.16.41,0,.57l25.62,25.64c.08.08.18.12.28.12h8.25c.22,0,.4-.18.4-.4Z" />
  </svg>
</template>

<script>
  export default {
    props: {
      iconName: {
        type: String,
        default: 'ai_redactor'
      },
      iconColor: {
        type: String,
        default: function() { return this.$vuetify.theme.currentTheme.defaultIconColor }
      },
      badgeColor: {
        type: String,
        default: function() { return this.$vuetify.theme.currentTheme.primary }
      },
    }
  }
</script>
